import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { EditHandlerForm } from './EditHandlerForm';
import { mapHandlerFormToRequest } from './mapHandlerFormToRequest.js';
import { mapHandlerRecordToFormValues } from './mapHandlerRecordToFormValues.js';
import { useHandlerById, useUpdateHandlerMutation } from './store';

export function EditHandlerPage() {
  const { t } = useTranslation();
  const { handlerId } = useParams();

  const { data: handlerData } = useHandlerById(handlerId);
  const updateMutation = useUpdateHandlerMutation();

  const values = useMemo(() => {
    if (!handlerData) return undefined;

    return mapHandlerRecordToFormValues(handlerData);
  }, [handlerData]);

  const onSubmit = async (data) => {
    const request = mapHandlerFormToRequest(data);

    await updateMutation.mutateAsync({ handlerId, data: request });
    toast.success(t('handlers:api.успешно обновлен'));
  };

  return (
    <EditHandlerForm
      onSubmit={onSubmit}
      values={values}
    />
  );
}
